export default __webpack_public_path__ + "static/coronavirus_kiss-3949121f0135dcf63a29919ca9fc8523.png";